<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import { CalendarDaysIcon } from '@heroicons/vue/24/outline'
import BlogSwiper from '@/Pages/User/Blogs/Partials/BlogSwiper.vue'

const props = defineProps({
    blog: {
        type: Object,
        required: true,
    },

    children_categories: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        :title="blog.title"
        :description="blog.meta_description"
    >
        <template #content>
            <div class="container mx-auto px-2 pb-20 pt-16 lg:pt-48 xl:px-0">
                <div class="gap-20 xl:grid xl:grid-cols-12">
                    <div class="relative col-span-12 mt-5 xl:col-span-5 xl:mt-0">
                        <div class="xl:sticky xl:top-48">
                            <div class="flex w-full justify-center">
                                <img
                                    :src="'/storage/blogs/' + blog.id + '/thumbnail/' + blog.thumbnail"
                                    :alt="blog.title"
                                    class="h-[500px] rounded-3xl object-cover object-center xl:h-[600px] 2xl:h-[700px]"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-span-12 xl:col-span-7">
                        <div class="mt-5 xl:mt-0">
                            <div>
                                <Link
                                    v-if="children_categories.length > 0"
                                    :aria-label="children_categories[0].relationships.parent.name"
                                    :href="route('blogs.category-index', children_categories[0].relationships.parent.slug)"
                                    class="faster-animation font-robotoSlab text-[24px] font-[400] text-gray-800 hover:text-red-500"
                                >
                                    {{ children_categories[0].relationships.parent.name }}
                                </Link>
                            </div>

                            <h1 class="my-2 font-robotoSlab text-[38px] font-bold">
                                {{ blog.title }}
                            </h1>

                            <ul class="flex items-center space-x-4">
                                <!-- <li
                                    class="flex items-center"
                                    v-for="children_category in children_categories"
                                    :key="children_category.id"
                                >
                                    <Link
                                        :aria-label="children_category.name"
                                        :href="
                                            route('blogs.category-index', {
                                                category:
                                                    children_category
                                                        .relationships.parent
                                                        .slug,
                                                childrens:
                                                    children_category.slug,
                                            })
                                        "
                                        class="faster-animation text-gray-600 hover:text-red-500 hover:underline"
                                    >
                                        {{ children_category.name }}
                                    </Link>

                                    <Link
                                        :aria-label="children_category.name"
                                        :href="route('blogs.category-index', {
                                            category: children_category.relationships.parent.slug,
                                            childrens: children_category.slug
                                        })"
                                        class="text-gray-600 hover:underline hover:text-red-500 faster-animation"
                                    >
                                        {{ children_category.name }}
                                    </Link>
                                </li> -->

                                <li class="h-1.5 w-1.5 rounded-full bg-red-500" />

                                <li class="flex items-center text-gray-600">
                                    <CalendarDaysIcon class="mr-2 h-5 w-5" />

                                    {{ blog.published_at }}
                                </li>

                                <template v-if="blog.relationships.bloggable">
                                    <li class="h-1.5 w-1.5 rounded-full bg-red-500" />
                                    <Link
                                        v-if="blog.bloggable_type === 'App\\Models\\Business'"
                                        :aria-label="blog.relationships.bloggable.title"
                                        :href="route('businesses.show', blog.relationships.bloggable.slug)"
                                        class="faster-animation text-gray-600 hover:text-red-500 hover:underline"
                                    >
                                        {{ blog.relationships.bloggable.title }}
                                    </Link>

                                    <Link
                                        v-else-if="blog.bloggable_type === 'App\\Models\\Service'"
                                        :aria-label="blog.relationships.bloggable.name"
                                        :href="route('services.show', blog.relationships.bloggable.slug)"
                                        class="faster-animation text-gray-600 hover:text-red-500 hover:underline"
                                    >
                                        {{ blog.relationships.bloggable.name }}
                                    </Link>
                                </template>
                            </ul>
                        </div>

                        <main class="mt-10">
                            <div
                                class="content-editor"
                                v-html="blog.first_content"
                            />

                            <BlogSwiper
                                v-if="blog.relationships.images.length > 0"
                                class="my-10"
                                :images="blog.relationships.images"
                            />

                            <div
                                class="content-editor"
                                v-html="blog.second_content"
                            />
                        </main>
                    </div>
                </div>
            </div>
        </template>
    </AppLayout>
</template>
